(function () {
  var root = document.getElementById('mg-chat');
  if (!root || !window.fetch) return;

  var api = ((document.body && document.body.getAttribute('data-wishlist-api')) || '/apps/mavigadget').replace(/\/+$/, '');
  var fab = root.querySelector('[data-mg-fab]');
  var fabTxt = root.querySelector('[data-mg-fab-txt]');
  var unreadEl = root.querySelector('[data-mg-unread]');
  var panel = root.querySelector('[data-mg-panel]');
  var bodyEl = root.querySelector('[data-mg-body]');
  var titleEl = root.querySelector('[data-mg-title]');
  var subEl = root.querySelector('[data-mg-sub]');
  var backBtn = root.querySelector('[data-mg-back]');
  var closeBtn = root.querySelector('[data-mg-close]');

  var SVG = 'http://www.w3.org/2000/svg';
  var TOKEN_KEY = 'mg_chat_token';
  var SEEN_KEY = 'mg_chat_last';
  var FG_DELAY = 3000, BG_DELAY = 12000, MAX_DELAY = 60000, TS_GAP = 5 * 60 * 1000;
  var cfg = null, token = null, lastId = 0, onBack = null;
  // Ids of the lines this tab sent and already shows. Kept apart from lastId: moving lastId past a sent line skipped
  // an agent reply that had landed a moment before it, never shown (theme check, 17 Oct 2026).
  var mine = {};
  // Polling: one self-rescheduling timer (never setInterval). errStreak drives backoff.
  var pollTimer = null, errStreak = 0;
  // Unread tracking. lastSeenId persists so a reply that arrived while away stays unread after reload.
  var lastSeenId = 0, unread = 0;
  // Live thread refs (set while the thread view is mounted, nulled otherwise).
  var activeThread = null, activeTsAt = 0, onThread = false, closedNoteShown = false;
  // The line they wait in, as the server last told it (place, usual wait, who is online). The card is the
  // one node showing it in the open thread; askNode asks a chat begun without an email for one.
  var queue = null, queueCard = null, askNode = null;

  /* ---- words ---- */
  // Every word a shopper reads comes from the theme's locale file (window.T, built from its `js` group), so it
  // reaches them in their own language; the English stays as the fallback. [n], [name]… are filled in here.
  function t(key, fallback, vars) {
    var s = (window.T && window.T[key]) || fallback;
    if (vars) for (var k in vars) if (Object.prototype.hasOwnProperty.call(vars, k)) s = s.split('[' + k + ']').join(String(vars[k]));
    return s;
  }
  function lang() { return (document.body && document.body.getAttribute('data-locale')) || document.documentElement.lang || undefined; }
  // "Matt and Cloe", in the shopper's own language.
  function listNames(names) {
    try { if (window.Intl && Intl.ListFormat) return new Intl.ListFormat(lang(), { style: 'long', type: 'conjunction' }).format(names); } catch (e) {}
    return names.join(', ');
  }
  function waitText(n) {
    if (n <= 1) return t('chat_wait_minute', 'about a minute');
    if (n < 50) return t('chat_wait_minutes', 'about [n] minutes', { n: n });
    if (n < 90) return t('chat_wait_hour', 'about an hour');
    return t('chat_wait_hours', 'a few hours');
  }
  function onlineText(names) {
    return names.length === 1
      ? t('chat_one_online', '[name] is online', { name: names[0] })
      : t('chat_many_online', '[names] are online', { names: listNames(names) });
  }

  /* ---- tiny DOM builder (no innerHTML) ---- */
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
      var v = attrs[k];
      if (v == null) continue;
      if (k === 'class') n.className = v;
      else if (k === 'text') n.textContent = v;
      else if (k.indexOf('on') === 0 && typeof v === 'function') n.addEventListener(k.slice(2), v);
      else n.setAttribute(k, v);
    }
    if (kids) for (var i = 0; i < kids.length; i++) {
      var c = kids[i];
      if (c == null) continue;
      n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    }
    return n;
  }
  // A line icon from its path data, drawn the way the other icons here are.
  function icon(paths, size, cls) {
    var s = document.createElementNS(SVG, 'svg');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('width', String(size || 18)); s.setAttribute('height', String(size || 18));
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '2');
    s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round'); s.setAttribute('aria-hidden', 'true');
    if (cls) s.setAttribute('class', cls);
    paths.forEach(function (d) { var p = document.createElementNS(SVG, 'path'); p.setAttribute('d', d); s.appendChild(p); });
    return s;
  }
  function chevron() { return icon(['M9 18l6-6-6-6'], 18, 'mg-chat__chev'); }
  function sendIcon() { return icon(['M22 2L11 13', 'M22 2l-7 20-4-9-9-4 20-7z'], 18); }
  function hourglassIcon() { return icon(['M5 22h14', 'M5 2h14', 'M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22', 'M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2'], 17); }
  function mailIcon() { return icon(['M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z', 'M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7'], 15, 'mg-chat__mail-ic'); }
  // A teammate's initial in a circle: the name they answer with, never a stock face.
  var AV_TINTS = ['#0f766e', '#7c3aed', '#b45309', '#be123c', '#1d4ed8', '#4d7c0f'];
  function avatar(name) {
    var h = 0; for (var i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
    var a = el('span', { class: 'mg-chat__av', text: (name.charAt(0) || '?').toUpperCase(), 'aria-hidden': 'true' });
    a.style.background = AV_TINTS[h % AV_TINTS.length];
    return a;
  }
  function setBody(node) { bodyEl.replaceChildren(node); }
  function isGuest() { return (document.body.getAttribute('data-logged-in') || 'false') !== 'true'; }
  function knownEmail() { return (document.body.getAttribute('data-customer-email') || '').trim(); }

  /* ---- show rules ---- */
  // 🚨 THE SAME PAGE IN EVERY LANGUAGE. The rule says "/pages/contact", and the German shopper stands on
  // /de/pages/kontakt: the language folder goes in front and the address itself is translated, so the chat
  // never showed outside English. A page is matched by its own address, by it without the language folder, and
  // by its English address, which Shopify names in the page's x-default link.
  function pagePaths() {
    var path = location.pathname || '/';
    var out = [path];
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (base !== '/' && path.indexOf(base) === 0) out.push('/' + path.slice(base.length));
    var alt = document.querySelector('link[rel="alternate"][hreflang="x-default"]');
    if (alt) { try { out.push(new URL(alt.getAttribute('href'), location.href).pathname); } catch (e) {} }
    return out;
  }
  function pageMatches(list) {
    var tmpl = root.getAttribute('data-template') || '';
    var paths = pagePaths();
    for (var i = 0; i < list.length; i++) {
      var p = String(list[i]).trim();
      if (!p) continue;
      if (p.charAt(0) === '/') {
        for (var j = 0; j < paths.length; j++) if (paths[j] === p || paths[j].indexOf(p) === 0) return true;
      }
      else if (tmpl === p || tmpl.indexOf(p) === 0) return true;
    }
    return false;
  }
  function visibleHere() {
    if (!wordsReady()) return false;
    var list = cfg.pages || [];
    if (cfg.mode === 'only') return pageMatches(list);
    if (cfg.mode === 'except') return !pageMatches(list);
    return true;
  }
  // ⚠️ NEVER AN ENGLISH CHAT ON A GERMAN PAGE. The chat's own words reach a language with the theme's nightly
  // translation run; until they have, a shopper in that language would read English buttons around a German
  // menu, so the chat waits for them. English is always ready.
  function wordsReady() {
    var l = String(shopLocale() || 'en').toLowerCase();
    if (l === 'en' || l.indexOf('en-') === 0) return true;
    var english = { chat_with_us: 'Chat with us', chat_start: 'Start chat', chat_type_placeholder: 'Type a message…' };
    for (var k in english) if (window.T && window.T[k] && window.T[k] !== english[k]) return true;
    return false;
  }
  function shopLocale() { return (window.Shopify && Shopify.locale) || lang() || ''; }

  /* ---- header + navigation ---- */
  function header(title, sub, back) {
    titleEl.textContent = title || '';
    subEl.textContent = sub || '';
    subEl.classList.remove('mg-chat__sub--live');
    onBack = back || null;
    backBtn.hidden = !back;
    // Any header render means we are leaving the thread view; openThread re-sets these
    // right after it calls header(). Keeps background unread counting correct elsewhere.
    onThread = false; activeThread = null; queueCard = null; askNode = null;
  }

  /* ---- views ---- */
  function showHome() {
    // What our replies really take, from the shop's own chats.
    var sub = cfg.usual_wait ? t('chat_usually_reply', 'We usually reply in [wait]', { wait: waitText(cfg.usual_wait) })
      : t('chat_reply_few_minutes', 'We typically reply in a few minutes');
    header(cfg.greeting || t('chat_hi', 'Hi! How can we help?'), sub, null);
    var wrap = el('div', { class: 'mg-chat__menu' });
    wrap.appendChild(el('div', { class: 'mg-chat__menu-h', text: cfg.home_title || t('chat_how_can_we_help', 'How can we help?') }));
    (cfg.menu || []).forEach(function (m) {
      if (!m.label) return;
      wrap.appendChild(el('button', {
        type: 'button', class: 'mg-chat__row',
        onclick: function () { pick(m); }
      }, [el('span', { text: m.label }), chevron()]));
    });
    var quick = (cfg.quick_replies || []).filter(Boolean);
    if (quick.length) {
      var chips = el('div', { class: 'mg-chat__chips' });
      quick.forEach(function (q) {
        chips.appendChild(el('button', { type: 'button', class: 'mg-chat__chip', onclick: function () { enterChat(q); } }, [q]));
      });
      wrap.appendChild(chips);
    }
    var outer = el('div', {}, [wrap, el('div', { class: 'mg-chat__foot', text: t('chat_powered_by', 'Powered by MaviGadget') })]);
    setBody(outer);
  }

  function pick(m) {
    if (m.type === 'answer') showAnswer(m);
    else if (m.type === 'link') { if (m.url && (/^https?:\/\//i.test(m.url) || m.url.charAt(0) === '/')) location.href = m.url; }
    else if (m.type === 'track') showTrack();
    else if (m.type === 'chat') enterChat('');
  }

  function showAnswer(m) {
    header(m.label, '', showHome);
    var view = el('div', { class: 'mg-chat__view' }, [
      el('div', { class: 'mg-chat__answer', text: m.body || t('chat_reach_out', 'Reach out and our team will help.') }),
      el('button', { type: 'button', class: 'mg-chat__btn', onclick: function () { enterChat(''); } }, [t('chat_still_need_help', 'Still need help? Chat with us')]),
      el('button', { type: 'button', class: 'mg-chat__btn mg-chat__btn--ghost', onclick: showHome }, [t('chat_back_to_menu', 'Back to menu')])
    ]);
    setBody(view);
  }

  /* ---- self-service order tracking ---- */
  function showTrack() {
    header(t('chat_track_title', 'Track my order'), t('chat_track_sub', 'Enter your email and order number'), showHome);
    var email = el('input', { class: 'mg-chat__input', type: 'email', placeholder: 'you@example.com', value: knownEmail() });
    var order = el('input', { class: 'mg-chat__input', type: 'text', placeholder: '#1042' });
    var err = el('div', { class: 'mg-chat__err' });
    var label = t('chat_find_order', 'Find my order');
    var btn = el('button', { type: 'button', class: 'mg-chat__btn' }, [label]);
    btn.addEventListener('click', function () {
      err.textContent = '';
      var e = email.value.trim(), o = order.value.trim();
      if (!e || !o) { err.textContent = t('chat_enter_both', 'Please enter both your email and order number.'); return; }
      btn.disabled = true; btn.textContent = t('chat_checking', 'Checking…');
      post('/chat/track-order', { email: e, order: o }).then(function (r) {
        btn.disabled = false; btn.textContent = label;
        if (r && r.found && r.order) showTrackResult(r.order);
        else if (r && r.disabled) err.textContent = t('chat_tracking_off', 'Order tracking is unavailable right now.');
        else err.textContent = t('chat_order_not_found', 'We could not find an order with that email and number. Please double-check both.');
      }).catch(function () { btn.disabled = false; btn.textContent = label; err.textContent = t('chat_went_wrong', 'Something went wrong. Please try again.'); });
    });
    setBody(el('div', { class: 'mg-chat__view' }, [
      el('div', { class: 'mg-chat__lead', text: t('chat_security_note', 'For your security we confirm both before showing any details.') }),
      el('label', { class: 'mg-chat__label', text: t('chat_email', 'Email') }), email,
      el('label', { class: 'mg-chat__label', text: t('chat_order_number', 'Order number') }), order,
      err, btn
    ]));
  }

  function statusLabel(o) {
    if (o.delivered_at) return t('chat_delivered', 'Delivered');
    var s = String(o.fulfillment_status || '').toUpperCase();
    if (s === 'FULFILLED') return t('chat_shipped', 'Shipped');
    if (s === 'PARTIALLY_FULFILLED') return t('chat_partly_shipped', 'Partially shipped');
    if (s === 'ON_HOLD') return t('chat_on_hold', 'On hold');
    if (s === 'UNFULFILLED' || s === '') return t('chat_preparing', 'Preparing to ship');
    return s.charAt(0) + s.slice(1).toLowerCase().replace(/_/g, ' ');
  }
  function prettyDate(v) {
    if (!v) return '';
    var d = new Date(v);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString(lang(), { year: 'numeric', month: 'short', day: 'numeric' });
  }
  // Local time for a bubble separator; prepend the date when the message is not from today.
  function formatTime(v) {
    var d = v ? new Date(v) : new Date();
    if (isNaN(d.getTime())) d = new Date();
    var now = new Date();
    var sameDay = d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
    var tm = d.toLocaleTimeString(lang(), { hour: 'numeric', minute: '2-digit' });
    if (sameDay) return tm;
    return d.toLocaleDateString(lang(), { month: 'short', day: 'numeric' }) + ', ' + tm;
  }
  function msAt(v) { var d = v ? new Date(v) : null; return d && !isNaN(d.getTime()) ? d.getTime() : Date.now(); }
  function showTrackResult(o) {
    header(t('chat_your_order', 'Your order'), o.order_name || '', showTrack);
    var card = el('div', { class: 'mg-chat__order' });
    card.appendChild(el('div', { class: 'mg-chat__order-top' }, [
      el('span', { class: 'mg-chat__order-name', text: o.order_name || t('order', 'Order').trim() }),
      el('span', { class: 'mg-chat__badge', text: statusLabel(o) })
    ]));
    var placed = prettyDate(o.placed_at);
    if (placed) card.appendChild(el('div', { class: 'mg-chat__note', text: t('chat_placed', 'Placed [date]', { date: placed }) }));
    (o.items || []).slice(0, 8).forEach(function (it) {
      var row = el('div', { class: 'mg-chat__item' });
      if (it.image) row.appendChild(el('img', { src: it.image, alt: '', loading: 'lazy' }));
      row.appendChild(el('div', {}, [
        el('div', { class: 'mg-chat__item-t', text: it.title || t('chat_item', 'Item') }),
        el('div', { class: 'mg-chat__item-q', text: t('chat_qty', 'Qty [n]', { n: it.quantity || 1 }) })
      ]));
      card.appendChild(row);
    });
    var link = (o.tracking && o.tracking.url) || o.status_url || '';
    var linkLabel = (o.tracking && o.tracking.url) ? t('chat_track_package', 'Track the package') : t('chat_view_status', 'View order status');
    var actions = [card];
    if (link && (/^https?:\/\//i.test(link))) {
      actions.push(el('a', { class: 'mg-chat__btn mg-chat__track-link', href: link, target: '_blank', rel: 'noopener' }, [linkLabel]));
    }
    if (o.tracking && o.tracking.number) {
      actions.push(el('div', { class: 'mg-chat__note', text: t('chat_tracking_number', 'Tracking [number]', { number: (o.tracking.company ? o.tracking.company + ' ' : '') + o.tracking.number }) }));
    }
    actions.push(el('button', { type: 'button', class: 'mg-chat__btn mg-chat__btn--ghost', onclick: function () { enterChat(''); } }, [t('chat_still_need_chat', 'Still need help? Chat')]));
    setBody(el('div', { class: 'mg-chat__view' }, actions));
  }

  /* ---- live chat / away ---- */
  // 🚨 AN EMAIL BEFORE EVERY NEW CHAT. A shopper who leaves a slow chat is answered by email, so the chat asks for
  // the address first; a signed-in customer's own address is used without asking.
  function enterChat(prefill) {
    if (token) { openThread(prefill); return; }
    if (!cfg.live_open) { showAway(); return; }
    if (!knownEmail() || (isGuest() && cfg.collect && cfg.collect.name)) { showPrechat(prefill); return; }
    startThread({}, prefill);
  }

  function validEmail(v) { return /.+@.+\..+/.test(v); }

  function showPrechat(prefill) {
    header(t('chat_with_us', 'Chat with us'), t('chat_few_details', 'A few details so we can help'), showHome);
    var askName = isGuest() && cfg.collect && cfg.collect.name;
    var name = el('input', { class: 'mg-chat__input', type: 'text', placeholder: t('chat_your_name', 'Your name'), autocomplete: 'name' });
    var email = el('input', { class: 'mg-chat__input', type: 'email', placeholder: 'you@example.com', autocomplete: 'email', value: knownEmail() });
    var err = el('div', { class: 'mg-chat__err' });
    var label = t('chat_start', 'Start chat');
    var btn = el('button', { type: 'button', class: 'mg-chat__btn' }, [label]);
    btn.addEventListener('click', function () {
      err.textContent = '';
      var hints = {};
      if (askName) { if (!name.value.trim()) { err.textContent = t('chat_enter_name', 'Please enter your name.'); return; } hints.name = name.value.trim(); }
      if (!validEmail(email.value.trim())) { err.textContent = t('chat_enter_email', 'Please enter a valid email.'); return; }
      hints.email = email.value.trim();
      btn.disabled = true;
      startThread(hints, prefill, function () { btn.disabled = false; err.textContent = t('chat_could_not_start', 'Could not start the chat. Please try again.'); });
    });
    var kids = [el('div', { class: 'mg-chat__lead', text: t('chat_connect_lead', 'We connect you with our team in a moment. If you need to go before we answer, the answer comes to your email.') })];
    if (askName) { kids.push(el('label', { class: 'mg-chat__label', text: t('chat_name', 'Name') })); kids.push(name); }
    kids.push(el('label', { class: 'mg-chat__label', text: t('chat_email', 'Email') })); kids.push(email);
    kids.push(err); kids.push(btn);
    setBody(el('div', { class: 'mg-chat__view' }, kids));
  }

  function showAway() {
    header(t('chat_leave_message', 'Leave a message'), t('chat_away_now', 'We are away right now'), showHome);
    var email = el('input', { class: 'mg-chat__input', type: 'email', placeholder: 'you@example.com', autocomplete: 'email', value: knownEmail() });
    var msg = el('textarea', { class: 'mg-chat__input', placeholder: t('chat_how_can_we_help', 'How can we help?') });
    var err = el('div', { class: 'mg-chat__err' });
    var label = t('send_message', 'Send message');
    var btn = el('button', { type: 'button', class: 'mg-chat__btn' }, [label]);
    btn.addEventListener('click', function () {
      err.textContent = '';
      if (!validEmail(email.value.trim())) { err.textContent = t('chat_enter_email', 'Please enter a valid email.'); return; }
      if (!msg.value.trim()) { err.textContent = t('chat_type_your_message', 'Please type your message.'); return; }
      btn.disabled = true; btn.textContent = t('sending', 'Sending…');
      post('/chat/start', { email: email.value.trim(), page: location.pathname }).then(function (r) {
        if (!r || !r.token) throw new Error('no token');
        token = r.token; saveToken();
        lastId = 0; unread = 0; lastSeenId = 0; saveSeen(); renderUnread();
        return post('/chat/message', { token: token, body: msg.value.trim() });
      }).then(function (r) {
        if (r && r.id) { lastId = Math.max(lastId, r.id); lastSeenId = lastId; saveSeen(); }
        // Not on the thread view, so a later reply surfaces as unread; start the background poll.
        onThread = false; activeThread = null;
        schedulePoll();
        setBody(el('div', { class: 'mg-chat__view' }, [
          el('div', { class: 'mg-chat__answer', text: t('chat_thanks_away', 'Thanks! We got your message and will reply by email as soon as we are back.') }),
          el('button', { type: 'button', class: 'mg-chat__btn mg-chat__btn--ghost', onclick: showHome }, [t('chat_back_to_menu', 'Back to menu')])
        ]));
      }).catch(function () { btn.disabled = false; btn.textContent = label; err.textContent = t('chat_could_not_send', 'Could not send. Please try again.'); });
    });
    setBody(el('div', { class: 'mg-chat__view' }, [
      el('div', { class: 'mg-chat__lead', text: cfg.away_message || t('chat_away_lead', 'Leave your email and your question and we will reply by email.') }),
      el('label', { class: 'mg-chat__label', text: t('chat_email', 'Email') }), email,
      el('label', { class: 'mg-chat__label', text: t('message', 'Message') }), msg,
      err, btn
    ]));
  }

  function startThread(hints, prefill, onFail) {
    hints = hints || {}; hints.page = location.pathname;
    post('/chat/start', hints).then(function (r) {
      if (!r || !r.token) throw new Error('no token');
      token = r.token; saveToken();
      lastId = 0; unread = 0; lastSeenId = 0; saveSeen(); renderUnread();
      openThread(prefill, r);
    }).catch(function () {
      if (onFail) { onFail(); return; }
      setBody(el('div', { class: 'mg-chat__view' }, [el('div', { class: 'mg-chat__err', text: t('chat_could_not_start', 'Could not start the chat. Please try again.') }),
        el('button', { type: 'button', class: 'mg-chat__btn mg-chat__btn--ghost', onclick: showHome }, [t('chat_back', 'Back')])]));
    });
  }

  // Mounts the live thread view. Used both for a fresh chat (started = the /chat/start
  // response with seed messages) and to auto-resume an existing token (resume = true),
  // in which case history is pulled via /chat/poll?after=0 once the view is in the DOM.
  function openThread(prefill, started, resume) {
    header(t('chat_with_us', 'Chat with us'), '', showHome);
    var thread = el('div', { class: 'mg-chat__thread' }, []);
    thread.setAttribute('aria-live', 'polite');
    activeThread = thread; activeTsAt = 0; onThread = true; closedNoteShown = false;
    // Greeting as the first agent bubble (no timestamp).
    addBubble(thread, { from: 'agent', body: cfg.greeting || t('chat_hi', 'Hi! How can we help?') }, { noTime: true });

    var input = el('textarea', { class: 'mg-chat__input', rows: '1', placeholder: t('chat_type_placeholder', 'Type a message…') });
    var send = el('button', { class: 'mg-chat__send', type: 'button', 'aria-label': t('send', 'Send') }, [sendIcon()]);

    function doSend() {
      var text = input.value.trim();
      if (!text) return;
      input.value = '';
      sendMessage(text, null);
    }
    send.addEventListener('click', doSend);
    input.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' && !ev.shiftKey) { ev.preventDefault(); doSend(); } });

    var quick = (cfg.quick_replies || []).filter(Boolean);
    var composerKids = [];
    if (quick.length) {
      var chips = el('div', { class: 'mg-chat__chips', style: 'padding:0 0 8px' });
      quick.forEach(function (q) { chips.appendChild(el('button', { type: 'button', class: 'mg-chat__chip', onclick: function () { input.value = ''; sendMessage(q, null); } }, [q])); });
      composerKids.push(chips);
    }
    composerKids.push(el('div', { class: 'mg-chat__composer-row' }, [input, send]));
    var composer = el('div', { class: 'mg-chat__composer' }, composerKids);

    var col = el('div', { style: 'display:flex;flex-direction:column;height:100%' }, [thread, composer]);
    bodyEl.replaceChildren(col);
    // make the thread the scroll area
    thread.style.flex = '1'; thread.style.overflowY = 'auto';

    // Seed history: from the /chat/start response now, or via poll?after=0 when resuming.
    var seed = (started && started.messages) || [];
    seed.forEach(function (m) { addBubble(thread, m); if (m.id) lastId = Math.max(lastId, m.id); });
    if (started && started.queue) applyQueue(started.queue);
    else if (queue) applyQueue(queue);
    scrollThread(thread);
    markSeenNow();

    // Focus the composer so a keyboard/screen-reader user lands on the input.
    try { input.focus(); } catch (e) {}

    if (resume) {
      get('/chat/poll?token=' + encodeURIComponent(token) + '&after=0').then(function (r) {
        if (!r || activeThread !== thread) return;
        if (r.status === 'unknown') { dropToken(); showHome(); return; }
        (r.messages || []).forEach(function (m) {
          addBubble(thread, m);
          if (m.id) lastId = Math.max(lastId, m.id);
        });
        applyStatus(thread, r.status);
        if (r.queue) applyQueue(r.queue);
        scrollThread(thread);
        markSeenNow();
      }).catch(function () {});
    }

    if (prefill) sendMessage(prefill, null);
    schedulePoll();
  }

  // Builds one bubble (with an optional time separator) and appends it. Returns the
  // bubble element so optimistic-send can later flip its pending/failed state.
  function addBubble(thread, m, opt) {
    opt = opt || {};
    if (!opt.noTime) {
      var at = msAt(m.at);
      if (activeTsAt === 0 || at - activeTsAt > TS_GAP) {
        thread.appendChild(el('div', { class: 'mg-chat__time', text: formatTime(m.at) }));
      }
      activeTsAt = at;
    }
    // "Matt joined the conversation", above the first line each person writes here.
    if (m.joined && m.author) {
      thread.appendChild(el('div', { class: 'mg-chat__joined' }, [avatar(m.author), el('span', { text: t('chat_joined', '[name] joined the conversation', { name: m.author }) })]));
    }
    var bubble;
    if (m.kind === 'away') {
      // The "we'll answer by email" line: a note about where the answer goes, not a person talking.
      bubble = el('div', { class: 'mg-chat__handover' }, [mailIcon(), el('span', { text: m.body || '' })]);
      thread.appendChild(bubble);
    } else {
      var wrap = el('div', { style: 'display:flex;flex-direction:column' });
      if (m.from === 'agent' && m.author) wrap.appendChild(el('div', { class: 'mg-chat__who', text: m.author }));
      var cls = 'mg-chat__bubble mg-chat__bubble--' + (m.from === 'you' ? 'you' : 'agent');
      if (opt.pending) cls += ' mg-chat__bubble--pending';
      bubble = el('div', { class: cls, text: m.body || '' });
      wrap.appendChild(bubble);
      thread.appendChild(wrap);
    }
    // The card about the line stays the last thing in the thread.
    if (queueCard && queueCard.parentNode === thread) thread.appendChild(queueCard);
    if (askNode && askNode.parentNode === thread) thread.appendChild(askNode);
    return bubble;
  }
  function markSent(bubble) { if (bubble) bubble.className = bubble.className.replace(/\s*mg-chat__bubble--pending/, ''); }
  function markFailed(bubble, text) {
    if (!bubble || !bubble.parentNode) return;
    bubble.className = bubble.className.replace(/\s*mg-chat__bubble--pending/, '') + ' mg-chat__bubble--failed';
    var wrap = bubble.parentNode;
    if (wrap.querySelector('.mg-chat__retry')) return;
    wrap.appendChild(el('button', {
      type: 'button', class: 'mg-chat__retry',
      onclick: function () { sendMessage(text, wrap); }
    }, [t('chat_not_sent', 'Not sent, tap to retry')]));
  }
  // The single optimistic-send path: render the shopper's bubble immediately (pending),
  // POST, then mark it sent, or mark it failed with a tap-to-retry button that resends
  // this exact text. `wrap` (when present) is the failed bubble being retried; it is removed.
  function sendMessage(text, wrap) {
    if (!activeThread) return;
    if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
    var pending = addBubble(activeThread, { from: 'you', body: text }, { pending: true });
    scrollThread(activeThread);
    post('/chat/message', { token: token, body: text }).then(function (r) {
      if (!r) throw new Error('no response');
      markSent(pending);
      if (r.id) { mine[r.id] = 1; if (onThread) { lastSeenId = Math.max(lastSeenId, r.id); saveSeen(); } }
      // Their place in the line, the moment they have written.
      if (r.queue) { applyQueue(r.queue); if (activeThread) scrollThread(activeThread); }
    }).catch(function () { markFailed(pending, text); if (activeThread) scrollThread(activeThread); });
  }
  function scrollThread(thread) { thread.scrollTop = thread.scrollHeight; }

  // Shows the "chat closed" note once when the server reports a closed conversation.
  function applyStatus(thread, status) {
    if (status === 'closed' && !closedNoteShown) {
      closedNoteShown = true;
      thread.appendChild(el('div', { class: 'mg-chat__sysnote', text: t('chat_closed_note', 'This chat was closed. Send a message to reopen it.') }));
    }
  }

  /* ---- the line they wait in ---- */
  // Everything here is what the server counted: the chats really waiting ahead, what our replies usually take,
  // and who on the team is in the admin now. Nobody online means no wait is promised.
  function applyQueue(q) {
    queue = q || null;
    if (!onThread || !activeThread) return;
    // Who is online sits in the header, with their initials, for the whole chat.
    var team = (queue && queue.team) || [];
    if (team.length) {
      var avs = el('span', { class: 'mg-chat__avatars' });
      team.slice(0, 3).forEach(function (n) { avs.appendChild(avatar(n)); });
      subEl.replaceChildren(avs, el('span', { text: onlineText(team) }));
      subEl.classList.add('mg-chat__sub--live');
    } else { subEl.textContent = ''; subEl.classList.remove('mg-chat__sub--live'); }
    renderQueueCard();
    renderEmailAsk();
  }

  function renderQueueCard() {
    var q = queue;
    var show = q && q.on && q.waiting && q.position;
    if (!show) { if (queueCard && queueCard.parentNode) queueCard.parentNode.removeChild(queueCard); queueCard = null; return; }

    var title = q.position <= 1 ? t('chat_next_in_line', "You're next in line") : t('chat_place_in_line', "You're number [n] in line", { n: q.position });
    var sub = q.wait_minutes ? t('chat_usual_wait', 'Usual wait: [wait]', { wait: waitText(q.wait_minutes) })
      : t('chat_team_away', "Our team is away right now. We'll answer as soon as we're back.");
    var kids = [el('div', { class: 'mg-chat__queue-top' }, [
      el('span', { class: 'mg-chat__queue-ic' }, [hourglassIcon()]),
      el('div', { class: 'mg-chat__queue-txt' }, [el('div', { class: 'mg-chat__queue-t', text: title }), el('div', { class: 'mg-chat__queue-s', text: sub })])
    ])];
    if (q.email) {
      kids.push(el('div', { class: 'mg-chat__queue-mail' }, [mailIcon(), el('span', {
        text: q.emailed ? t('chat_email_promised', 'Our answer will also go to [email].', { email: q.email })
          : t('chat_email_backup', "If you need to go, we'll email our answer to [email].", { email: q.email })
      })]));
    }
    var card = el('div', { class: 'mg-chat__queue', role: 'status' }, kids);
    if (queueCard && queueCard.parentNode) queueCard.parentNode.replaceChild(card, queueCard);
    else activeThread.appendChild(card);
    queueCard = card;
    if (askNode && askNode.parentNode === activeThread) activeThread.appendChild(askNode);
  }

  // A chat begun before we asked for an address: ask for it once, in the thread, so the answer can reach them.
  function renderEmailAsk() {
    if (!queue || !queue.needs_email) { if (askNode && askNode.parentNode) askNode.parentNode.removeChild(askNode); askNode = null; return; }
    if (askNode) return;
    var input = el('input', { class: 'mg-chat__input', type: 'email', placeholder: 'you@example.com', autocomplete: 'email', value: knownEmail() });
    var err = el('div', { class: 'mg-chat__err' });
    var btn = el('button', { type: 'button', class: 'mg-chat__btn' }, [t('save', 'Save')]);
    btn.addEventListener('click', function () {
      err.textContent = '';
      var v = input.value.trim();
      if (!validEmail(v)) { err.textContent = t('chat_enter_email', 'Please enter a valid email.'); return; }
      btn.disabled = true;
      post('/chat/start', { token: token, email: v }).then(function (r) {
        btn.disabled = false;
        if (r && r.queue) applyQueue(r.queue);
      }).catch(function () { btn.disabled = false; err.textContent = t('chat_could_not_send', 'Could not send. Please try again.'); });
    });
    askNode = el('div', { class: 'mg-chat__ask' }, [
      el('div', { class: 'mg-chat__ask-t', text: t('chat_where_answer', 'Where should we send our answer?') }), input, err, btn
    ]);
    activeThread.appendChild(askNode);
  }

  /* ---- unread badge ---- */
  function renderUnread() {
    if (unread > 0) {
      unreadEl.textContent = unread > 9 ? '9+' : String(unread);
      unreadEl.hidden = false;
    } else {
      unreadEl.textContent = '';
      unreadEl.hidden = true;
    }
  }
  // Called when the shopper is looking at the live thread: everything is now read.
  function markSeenNow() {
    lastSeenId = Math.max(lastSeenId, lastId);
    saveSeen();
    if (unread !== 0) { unread = 0; renderUnread(); }
  }
  function saveSeen() { try { localStorage.setItem(SEEN_KEY, String(lastSeenId)); } catch (e) {} }

  /* ---- single poll scheduler (no setInterval) ---- */
  // One self-rescheduling timer runs whenever a token exists, even with the panel closed,
  // so agent replies surface as an unread badge. Faster in the foreground, slower in the
  // background; paused while the tab is hidden; exponential backoff on consecutive errors.
  function pollDelay() {
    var base = (!panel.hidden && onThread) ? FG_DELAY : BG_DELAY;
    if (errStreak > 0) base = Math.min(MAX_DELAY, base * Math.pow(2, errStreak));
    return base;
  }
  function schedulePoll() {
    stopPoll();
    if (!token) return;
    pollTimer = setTimeout(pollOnce, pollDelay());
  }
  function stopPoll() { if (pollTimer) { clearTimeout(pollTimer); pollTimer = null; } }
  function pollOnce() {
    pollTimer = null;
    if (!token) return;
    if (document.hidden) { return; }   // visibilitychange will resume us
    get('/chat/poll?token=' + encodeURIComponent(token) + '&after=' + lastId).then(function (r) {
      errStreak = 0;
      if (!r) { schedulePoll(); return; }
      if (r.status === 'unknown') { dropToken(); return; }
      var viewing = onThread && !panel.hidden && activeThread;
      var gotAgent = false;
      (r.messages || []).forEach(function (m) {
        if (!m.id || m.id <= lastId) return;
        lastId = m.id;
        if (mine[m.id]) return;   // this tab's own line, already on screen
        if (m.from === 'agent') {
          gotAgent = true;
          if (viewing) addBubble(activeThread, m);
          else if (m.id > lastSeenId) unread++;
        } else if (viewing) {
          // A shopper line from another device/tab.
          addBubble(activeThread, m);
        }
      });
      if (r.queue) applyQueue(r.queue);
      if (viewing) { applyStatus(activeThread, r.status); markSeenNow(); scrollThread(activeThread); }
      if (gotAgent && !viewing) renderUnread();
      schedulePoll();
    }).catch(function () { errStreak = Math.min(errStreak + 1, 8); schedulePoll(); });
  }
  function dropToken() { token = null; queue = null; clearToken(); stopPoll(); }

  /* ---- transport ---- */
  // Every call says the shopper's language: Shopify does not pass it to the app, and the chat's words, the
  // "we'll email you" message and the mail that follows are written in it.
  function withLang(path) {
    var l = shopLocale();
    return l ? path + (path.indexOf('?') >= 0 ? '&' : '?') + 'lang=' + encodeURIComponent(l) : path;
  }
  function get(path) { return fetch(api + withLang(path), { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(okJson); }
  function post(path, data) {
    data = data || {};
    // Same guest identity the wishlist uses, so a chat lands on the shopper's activity timeline.
    if (data.guest_token == null) { try { var gt = localStorage.getItem('mg_wishlist_guest'); if (gt) data.guest_token = gt; } catch (e) {} }
    return fetch(api + withLang(path), { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) }).then(okJson);
  }
  function okJson(r) { return r && r.ok ? r.json() : null; }
  function saveToken() { try { localStorage.setItem(TOKEN_KEY, token); } catch (e) {} }
  function clearToken() { try { localStorage.removeItem(TOKEN_KEY); } catch (e) {} }

  /* ---- open/close ---- */
  function firstFocusable() {
    return panel.querySelector('textarea, input, button:not([hidden]), a[href], [tabindex]:not([tabindex="-1"])');
  }
  function open() {
    panel.hidden = false;
    fab.setAttribute('aria-expanded', 'true');
    // Auto-resume: if a conversation exists, go straight into the thread and clear unread.
    if (token) { openThread('', null, true); }
    else if (!bodyEl.firstChild || !onThread) { showHome(); }
    unread = 0; renderUnread();
    schedulePoll();   // switch to the faster foreground cadence
    // Focus the first interactive element so keyboard/AT users land inside the panel.
    setTimeout(function () { var f = firstFocusable(); if (f) try { f.focus(); } catch (e) {} }, 0);
  }
  function close() {
    panel.hidden = true;
    fab.setAttribute('aria-expanded', 'false');
    onThread = false; activeThread = null; queueCard = null; askNode = null;
    schedulePoll();   // keep the background poll alive for unread; just slower
    try { fab.focus(); } catch (e) {}   // return focus to the launcher
  }
  fab.addEventListener('click', function () { panel.hidden ? open() : close(); });
  closeBtn.addEventListener('click', close);
  backBtn.addEventListener('click', function () { if (onBack) onBack(); });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !panel.hidden) { ev.stopPropagation(); close(); }
  });
  // Pause polling while the tab is hidden; resume (and immediately poll) when it returns.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stopPoll(); }
    else if (token) { errStreak = 0; stopPoll(); pollTimer = setTimeout(pollOnce, 0); }
  });

  /* ---- boot ---- */
  // 🚨 THE SETTINGS ONCE PER FIVE MINUTES, not once per page: ~117,000 fetches on 20 Oct 2026 for a payload that is
  // the same for every shopper. Kept per language. ⚠️ Five minutes, not longer: it carries whether the team is online
  // (live_open) and the usual wait, and the app already holds it up to fifteen minutes on its side.
  var CFG_KEY = 'mg_chat_cfg_', CFG_MS = 300000;
  function chatConfig() {
    var key = CFG_KEY + (shopLocale() || '');
    try {
      var hit = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (hit && hit.c && Date.now() - hit.t < CFG_MS) return Promise.resolve(hit.c);
    } catch (e) {}
    return get('/chat/config').then(function (c) {
      try { if (c) sessionStorage.setItem(key, JSON.stringify({ c: c, t: Date.now() })); } catch (e) {}
      return c;
    });
  }
  function boot() {
    chatConfig().then(function (c) {
      if (!c || !c.enabled) return;
      cfg = c;
      if (!visibleHere()) return;
      root.style.setProperty('--mg-accent', cfg.color || '#18181b');
      if (cfg.launcher_text) fabTxt.textContent = cfg.launcher_text;
      // ⚠️ Signed out after somebody was signed in on this browser: their chat is not handed to the next person.
      // {@see forgetSignedInCustomer in theme.js}, which this does not wait for.
      try { if (document.body.getAttribute('data-logged-in') === 'false' && localStorage.getItem('mg_last_cid')) { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(SEEN_KEY); } } catch (e) {}
      try { token = localStorage.getItem(TOKEN_KEY) || null; } catch (e) { token = null; }
      try { lastSeenId = parseInt(localStorage.getItem(SEEN_KEY), 10) || 0; } catch (e) { lastSeenId = 0; }
      if (token) lastId = lastSeenId;   // only count replies newer than what we last saw
      root.hidden = false;
      fab.hidden = false;
      document.documentElement.classList.add('mg-chat-on');   // lifts the theme's back-to-top clear of the launcher
      // If a conversation already exists, run the background poll so a reply that arrived
      // while away shows as an unread badge without the shopper opening the panel first.
      if (token) schedulePoll();
    }).catch(function () {});
  }
  // A pre-loaded page boots the chat when it is shown, not while it is hidden. {@see mgWhenShown} in theme.js
  function bootSoon() { if ('requestIdleCallback' in window) requestIdleCallback(boot); else setTimeout(boot, 800); }
  try { if (document.prerendering) { document.addEventListener('prerenderingchange', bootSoon, { once: true }); } else { bootSoon(); } } catch (e) { bootSoon(); }
})();
